const LONG_PRESS_MS = 350;
const TOUCH_SLOP = 8;
const MOUSE_DRAG_DISTANCE = 4;

/** Own one pointer until release; cancellation must never commit a drop. */
export function trackBlockDrag(
  pointer: Pick<PointerEvent, 'pointerId' | 'pointerType' | 'clientX' | 'clientY'>,
  callbacks: {
    begin: () => void;
    move: (event: PointerEvent) => void;
    drop: () => void;
    cancel: () => void;
  },
): () => void {
  const touch = pointer.pointerType === 'touch';
  let dragging = false;
  let timer: number | undefined;
  const begin = (): void => {
    dragging = true;
    callbacks.begin();
  };
  const cleanup = (): void => {
    window.clearTimeout(timer);
    window.removeEventListener('pointermove', move);
    window.removeEventListener('pointerup', up);
    window.removeEventListener('pointercancel', cancelPointer);
    window.removeEventListener('blur', cancel);
  };
  const cancel = (): void => {
    cleanup();
    callbacks.cancel();
  };
  const move = (event: PointerEvent): void => {
    if (event.pointerId !== pointer.pointerId) return;
    const distance = Math.hypot(event.clientX - pointer.clientX, event.clientY - pointer.clientY);
    if (!dragging) {
      if (touch) {
        if (distance > TOUCH_SLOP) cancel();
        return;
      }
      if (distance < MOUSE_DRAG_DISTANCE) return;
      begin();
    }
    event.preventDefault();
    callbacks.move(event);
  };
  const up = (event: PointerEvent): void => {
    if (event.pointerId !== pointer.pointerId) return;
    cleanup();
    if (dragging) {
      callbacks.move(event);
      callbacks.drop();
    } else callbacks.cancel();
  };
  const cancelPointer = (event: PointerEvent): void => {
    if (event.pointerId === pointer.pointerId) cancel();
  };
  if (touch) timer = window.setTimeout(begin, LONG_PRESS_MS);
  window.addEventListener('pointermove', move, { passive: false });
  window.addEventListener('pointerup', up);
  window.addEventListener('pointercancel', cancelPointer);
  window.addEventListener('blur', cancel);
  return cancel;
}
